/* eslint-disable */
export default {
  rateExceeded:
    'Pyyntöraja ylitetty. Sovellus palaa käyttöön {ttl} sekunnin kuluttua.',
} as const;

// @key: @#@"rateExceeded"@#@ @source: @#@"Request limit exceeded. App will resume in {ttl} seconds."@#@
